// extracted by mini-css-extract-plugin
export default {"component":"dateNav__component___PsIHS","navLink":"dateNav__navLink___qTTfc","navLinkPrev":"dateNav__navLinkPrev___5S-Rn","navLinkNext":"dateNav__navLinkNext___C5bBO"};